import { render, staticRenderFns } from "./PatientPrescriptions.vue?vue&type=template&id=98662246"
import script from "./PatientPrescriptions.vue?vue&type=script&lang=js"
export * from "./PatientPrescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports